import { BaseService } from "../../base-service";

export interface Facilities {
    facilityId?: string;
    facilityName?: string;
    organisationId?:string;
}

class FacilitiesApi {
    async getUserFacilities() {
        const path = `/api/v1/facilities/user-facilities`;
        let response = await BaseService.AsyncGet(path);
        return response as Facilities[];
    }
}
const facilityService = new FacilitiesApi();

export { facilityService };